<template>
  <div class="dialog-mask payment-method-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div>
        <div class="floating-label">
          <input v-model="payment.fullname" placeholder=" " type="text" :class="{ invalid: !payment.fullname }" />
          <label>{{ 'CreditCardFullName' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="payment.Description" placeholder=" " type="text" :class="{ invalid: !payment.Description }" />
          <label>{{ 'PaymentDescription' | lang }}</label>
        </div>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(payment)" :disabled="!payment.fullname || !payment.Description">{{ 'Save' | lang }}</button>
        <button @click="sweetClose()">{{ 'Undo' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'CartPaymentNewMethodDialog',
  mixins: [ dialogMixin ],
  props: ['methods'],
  data () {
    return {
      payment: {
        Description: '',
        fullname: ''
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

</style>
